 
import React, { FC, useEffect, useState } from 'react';
import { NegativeTagName, PositiveTagName } from '@gumtree/web-bff/src/api/clients/user-reviews';
import { useDispatch, useSelector } from 'react-redux';
import { trackV2 } from '@gumtree/shared/src/util/track-ga-event';
import { StyledFeedbackContainer, StyledPill } from './style';
import { MessageCentreState, MessageCentreUseDispatch } from '../../../../reducers';
import {
    onGranularResponse,
    onGranularResponseNegative,
    onGranularResponsePositive,
} from '../../../../reducers/actions';

const GranularFeedback: FC<FeedbackProps> = ({
    selectedInteractedRating,
    converseeName,
    stageNumber,
    newFlow = false,
}) => {
    const positiveRating = selectedInteractedRating === 5;
    const { granularResponse, positiveResponse, negativeResponse } = useSelector(selectState);
    const dispatch = useDispatch() as MessageCentreUseDispatch;
    const [noneSelected, setNoneSelected] = useState<boolean>(false);

    useEffect(() => {
        setNoneSelected(false);
    }, [stageNumber]);

    const responseType = stageNumber === 2 ? positiveResponse : negativeResponse;

    useEffect(() => {
        trackV2('UserFeedbackBegin');
    }, []);

    const tagName = newFlow
        ? stageNumber === 2
            ? PositiveTagName
            : NegativeTagName
        : positiveRating
        ? PositiveTagName
        : NegativeTagName;

    const isActive = (el) => (newFlow ? responseType.includes(el) : granularResponse.includes(el));

    const handleClick = (el) => {
        if (newFlow) {
            if (stageNumber === 2) {
                dispatch(onGranularResponsePositive(el));
            } else {
                dispatch(onGranularResponseNegative(el));
            }
        } else {
            dispatch(onGranularResponse(el));
        }
    };

    return (
        <>
            {!newFlow && (
                <p style={{ textAlign: 'center' }}>
                    {!positiveRating
                        ? `What did not go well when dealing with ${converseeName}?`
                        : `What went well when dealing with ${converseeName}?`}
                </p>
            )}
            <StyledFeedbackContainer newFlow>
                {Object.values(tagName).map((el: string) => (
                    <StyledPill
                        disabled={noneSelected}
                        newFlow={newFlow}
                        icon={newFlow && responseType.includes(el)}
                        iconType="check"
                        key={el}
                        className={isActive(el) ? 'active' : ''}
                        title={el}
                        type={newFlow ? 'neutral' : positiveRating ? 'positive' : 'negative'}
                        dataQ="feedback-pill"
                        onClick={() => handleClick(el)}
                    />
                ))}
                {newFlow && (
                    <StyledPill
                        newFlow
                        key="noneofthese"
                        icon={noneSelected}
                        iconType="check"
                        className={noneSelected ? 'active' : ''}
                        title="None of these"
                        type="neutral"
                        dataQ="feedback-pill"
                        onClick={() => {
                            setNoneSelected(!noneSelected);
                            stageNumber === 2
                                ? dispatch(onGranularResponsePositive('none'))
                                : dispatch(onGranularResponseNegative('none'));
                        }}
                    />
                )}
            </StyledFeedbackContainer>
        </>
    );
};

interface FeedbackProps {
    selectedInteractedRating: number;
    converseeName: string;
    stageNumber?: number;
    newFlow?: boolean;
}

export default GranularFeedback;

function selectState({
    messageCentre: { granularResponse, positiveResponse, negativeResponse },
}: MessageCentreState) {
    return {
        granularResponse,
        positiveResponse,
        negativeResponse,
    };
}
